import React from 'react';

function MyInput() {
  return (
    <input
      type="text"
      className="pl-4 rounded w-full h-full"
      placeholder="Search by address"
    />
  );
}

export default MyInput;
